import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveContainerQrRedirectionCampaignMutationVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;


export type RemoveContainerQrRedirectionCampaignMutation = { __typename?: 'Mutation', removeContainerQrRedirectionCampaign?: { __typename?: 'ContainerQrRedirectionCampaign', id: number } | null };


export const RemoveContainerQrRedirectionCampaignDocument = gql`
    mutation removeContainerQrRedirectionCampaign($id: Int!) {
  removeContainerQrRedirectionCampaign(id: $id) {
    id
  }
}
    `;
export type RemoveContainerQrRedirectionCampaignMutationFn = Apollo.MutationFunction<RemoveContainerQrRedirectionCampaignMutation, RemoveContainerQrRedirectionCampaignMutationVariables>;

/**
 * __useRemoveContainerQrRedirectionCampaignMutation__
 *
 * To run a mutation, you first call `useRemoveContainerQrRedirectionCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveContainerQrRedirectionCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeContainerQrRedirectionCampaignMutation, { data, loading, error }] = useRemoveContainerQrRedirectionCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveContainerQrRedirectionCampaignMutation(baseOptions?: Apollo.MutationHookOptions<RemoveContainerQrRedirectionCampaignMutation, RemoveContainerQrRedirectionCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveContainerQrRedirectionCampaignMutation, RemoveContainerQrRedirectionCampaignMutationVariables>(RemoveContainerQrRedirectionCampaignDocument, options);
      }
export type RemoveContainerQrRedirectionCampaignMutationHookResult = ReturnType<typeof useRemoveContainerQrRedirectionCampaignMutation>;
export type RemoveContainerQrRedirectionCampaignMutationResult = Apollo.MutationResult<RemoveContainerQrRedirectionCampaignMutation>;
export type RemoveContainerQrRedirectionCampaignMutationOptions = Apollo.BaseMutationOptions<RemoveContainerQrRedirectionCampaignMutation, RemoveContainerQrRedirectionCampaignMutationVariables>;